import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { CreateGameInput, Game, UpdateGameInput } from './games-types';

const KEYS = {
  all: ['games'] as const,
  list: () => [...KEYS.all, 'list'] as const,
};

export function useGames() {
  return useQuery({
    queryKey: KEYS.list(),
    queryFn: async () => {
      const r = await apiClient.get<Game[]>('/admin/games');
      return r.data;
    },
  });
}

export function useCreateGame() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateGameInput) => apiClient.post<Game>('/admin/games', input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
}

export function useUpdateGame() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateGameInput }) =>
      apiClient.patch<Game>(`/admin/games/${id}`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
}

export function useDeleteGame() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.delete(`/admin/games/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
}
